module.exports = __webpack_public_path__ + "img/LogoXbatt_Gris.a05b2050.png";